var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad30" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [
        _vm._v("促销管理--优惠活动列表")
      ]),
      _c("div", { staticClass: "box20" }),
      [
        _c(
          "div",
          { staticClass: "status-container" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.activeStateChange },
                model: {
                  value: _vm.searchForm.activeState,
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "activeState", $$v)
                  },
                  expression: "searchForm.activeState"
                }
              },
              [
                _c("el-tab-pane", {
                  attrs: { label: "全部活动", name: "ALL" }
                }),
                _c("el-tab-pane", {
                  attrs: { label: "未开始", name: "NOT_START" }
                }),
                _c("el-tab-pane", {
                  attrs: { label: "进行中", name: "HAVE_IN_HAND" }
                }),
                _c("el-tab-pane", {
                  attrs: { label: "已结束", name: "ALREADY_OVER" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      _c(
        "div",
        { staticClass: "flex flex-wrap flex1 items-center mar20-b" },
        [
          _c(
            "div",
            [
              _c("span", [_vm._v("活动名称：")]),
              _c("el-input", {
                staticClass: "w210 mar20_r",
                attrs: { placeholder: "请输入活动名称" },
                model: {
                  value: _vm.searchForm.promotionName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.searchForm,
                      "promotionName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "searchForm.promotionName"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c("span", [_vm._v("活动类型：")]),
              _c(
                "el-select",
                {
                  staticClass: "w210 mar20_r",
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.searchForm.promotionType,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "promotionType", $$v)
                    },
                    expression: "searchForm.promotionType"
                  }
                },
                _vm._l(_vm.promotionTypeList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.getList } },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              staticClass: "mar-20-l",
              attrs: { type: "primary" },
              on: { click: _vm.addPromotionType }
            },
            [_vm._v("新增促销活动")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, "row-key": "id", height: "450" },
          on: { "selection-change": _vm.promotionSelect }
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", "reserve-selection": true, width: "55" }
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "promotionName",
              label: "活动名称"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "promotionType", label: "活动类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.promotionType === "DIRECT_SELLING"
                      ? _c("span", [_vm._v("直降")])
                      : _vm._e(),
                    scope.row.promotionType === "DISCOUNT"
                      ? _c("span", [_vm._v("折扣")])
                      : _vm._e(),
                    scope.row.promotionType === "BUY_GIFTS"
                      ? _c("span", [_vm._v("买赠")])
                      : _vm._e(),
                    scope.row.promotionType === "GROUP_PURCHASE"
                      ? _c("span", [_vm._v("集采")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "cartNum", label: "货品数" }
          }),
          _c("el-table-column", {
            attrs: { prop: "startDate", label: "开始时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "endDate", label: "结束时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "activeState", label: "活动状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.activeState === "NOT_START"
                      ? _c("span", [_vm._v("未开始")])
                      : _vm._e(),
                    scope.row.activeState === "HAVE_IN_HAND"
                      ? _c("span", [_vm._v("进行中")])
                      : _vm._e(),
                    scope.row.activeState === "ALREADY_OVER"
                      ? _c("span", [_vm._v("已结束")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.activeState !== "ALREADY_OVER"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.updatePromotion(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    scope.row.activeState !== "HAVE_IN_HAND"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mar15-l",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.deletePromotion(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    scope.row.activeState === "HAVE_IN_HAND"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mar15-l",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.stopPromotion(scope.row)
                              }
                            }
                          },
                          [_vm._v("结束")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex items-center mar20-t" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.updatePromotionList }
            },
            [_vm._v("结束活动")]
          ),
          _c(
            "el-button",
            {
              staticClass: "mar-20-l",
              attrs: { type: "primary" },
              on: { click: _vm.deletePromotionList }
            },
            [_vm._v("删除活动")]
          ),
          _c("div", { staticClass: "gray9 flex-auto mar-20-l" }, [
            _vm._v(
              "共 " +
                _vm._s(_vm.pageTotal) +
                " 条记录 第 " +
                _vm._s(_vm.pageNum) +
                " / " +
                _vm._s(_vm.totalPage) +
                " 页"
            )
          ]),
          _c("el-pagination", {
            attrs: {
              layout: "prev, pager, next, sizes, jumper",
              background: "",
              "hide-on-single-page": "",
              "page-size": _vm.pageSize,
              "page-count": _vm.totalPage,
              "current-page": _vm.pageNum,
              "page-sizes": [6, 10, 20]
            },
            on: {
              "update:pageSize": function($event) {
                _vm.pageSize = $event
              },
              "update:page-size": function($event) {
                _vm.pageSize = $event
              },
              "update:currentPage": function($event) {
                _vm.pageNum = $event
              },
              "update:current-page": function($event) {
                _vm.pageNum = $event
              },
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }